import { useNavigate } from 'react-router-dom';
import { DECOR_VIDEO_URL } from '@pomoshnik/shared';
import { Header } from '@/components/Header/Header';
import { BottomBar } from '@/components/BottomBar/BottomBar';
import { VideoButton } from '@/components/VideoButton';

/**
 * Экран 2.2.1 — выбор kind декора (PRD §5; обновлено в Phase 5 под актуальную
 * 3-kind семантику после P-033 расширения Phase 1).
 *
 * 3 kind'а соответствуют xlsx-канону `decors-base-schema.md` (Phase 3 разведка):
 *   - Фасады (facade)     — МДФ Пленка / МДФ ламинированный (ADR-0056).
 *   - Столешницы (countertop) — Столешницы ЛДСП / HPL / Камень акрил/кварц (ADR-0056).
 *   - Корпус (panel)      — ЛДСП / ЛДСП влагостойкая.
 *
 * Первый элемент контента — `<VideoButton>` (PRD §16.4 / B-008).
 * Дочерний экран 2.2.2 (выбор метода подбора) появится в Phase 6+.
 */
export function KindPicker() {
  const navigate = useNavigate();

  return (
    <main className="min-h-screen flex flex-col bg-canvas">
      <Header title="Что подбираем?" />

      <div className="flex-1 flex flex-col gap-4 p-6">
        <VideoButton videoUrl={DECOR_VIDEO_URL} />
        <KindButton label="Фасады" onClick={() => navigate('/decors/facade')} />
        <KindButton label="Столешницы" onClick={() => navigate('/decors/countertop')} />
        <KindButton label="Корпус (ЛДСП)" onClick={() => navigate('/decors/panel')} />
      </div>

      <BottomBar />
    </main>
  );
}

interface KindButtonProps {
  label: string;
  onClick: () => void;
}

function KindButton({ label, onClick }: KindButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={label}
      className={
        'min-h-tap-chip-lg w-full rounded-xl bg-card border-[1.5px] border-accent ' +
        'text-ink font-display text-h2 shadow-card ' +
        'focus-visible:ring-2 focus-visible:ring-cta focus-visible:outline-none active:opacity-90'
      }
      style={{ minHeight: 120 }}
    >
      {label}
    </button>
  );
}
